export default __webpack_public_path__ + "static/media/UB_logotyp_cremevit_RGB.8e7d215f.png";